import React, { useState, ReactElement } from 'react';

import MultiSelect from '@/components/forms/select/MultiSelect';
import ToggleButton from '@/components/forms/toggle_button';
import Container, { ContainerTypes } from '@/components/commons/page-elements/Container';

import { CALENDAR_CATEGORIES_OPTIONS } from '../alerts/Constants';

interface Props {
    readonly id: string; // unique id of calendar instance
    readonly header: ReactElement;
    readonly categories: Array<string>;
    readonly visible: boolean;
    readonly externalStyles?: string;
}

function CalendarCard({
    id,
    header,
    categories,
    visible,
    externalStyles = null,
}: Props) {
    const [checked, setChecked] = useState(visible);

    return (
        <Container type={ContainerTypes.WHITE} externalStyles={externalStyles}>
            {header}
            <MultiSelect
                placeholder="Calendar Type"
                options={CALENDAR_CATEGORIES_OPTIONS}
                defaultOptions={categories}
                name={`categories-${id}`}
            />
            <ToggleButton
                label="Enabled"
                checked={checked}
                onChange={() => setChecked(!checked)}
                name={`visible-${id}`}
            />
        </Container>
    );
}

export default CalendarCard;
